<div class="pg-footer">
    <footer class="footer">
      <svg class="footer-wave-svg" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 1200 100" preserveAspectRatio="none">
        <path class="footer-wave-path" d="M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z"></path>
      </svg>
      <div class="footer-content">
        <div class="footer-content-column">
  
          <div class="footer-menu">
            <h2 class="footer-menu-name">Comienza ahora</h2>
            <ul id="menu-get-started" class="footer-menu-list">
              <li id="menu-item-173730" class="menu-item menu-item-type-post_type menu-item-object-product menu-item-173730">
                <a href="landing-form">Reservar Asesoría Online - Videollamada</a>
              </li>
              <!-- <li id="menu-item-173728" class="menu-item menu-item-type-post_type menu-item-object-product menu-item-173728">
                <a href="#">Comprar Guías PDF</a>
              </li> -->
              <!-- <li id="menu-item-173727" class="menu-item menu-item-type-post_type menu-item-object-product menu-item-173727">
                <a href="#">Tours Online</a>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer-content-column">
          <div class="footer-menu">
            <h2 class="footer-menu-name">Nosotros</h2>
            <ul id="menu-company" class="footer-menu-list">
              <li id="menu-item-167408" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-167408">
                <a target="_blank" href="https://www.instagram.com/voyjaleas/">Instagram</a>
              </li>
              <li id="menu-item-167408" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-167408">
                <a href="contact">Contacto</a>
              </li>
              <!-- <li id="menu-item-167409" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-167409">
                <a href="about">Nuestro Equipo</a>
              </li> -->
              <!-- <li id="menu-item-171917" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-171917">
                <a href="#">Reservar 1h asesoría online</a>
              </li> -->
            </ul>
          </div>
          <!-- <div class="footer-menu">
            <h2 class="footer-menu-name">Legal</h2>
            <ul id="menu-legal" class="footer-menu-list">
              <li id="menu-item-170434" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-170434">
                <a href="#">Copyright</a>
              </li>
              <li id="menu-item-179115" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-179115">
                <a href="#">Política de Cookies</a>
              </li>
              <li id="menu-item-178960" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-178960">
                <a href="#">Términos y condiciones</a>
              </li>
            </ul>
          </div> -->
        </div>
        <div class="footer-content-column">
          <div class="footer-menu">
            <h2 class="footer-menu-name">Mapa del Sitio</h2>
            <ul id="menu-quick-links" class="footer-menu-list">
              <li id="menu-item-168092" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-168092">
                <a rel="noopener noreferrer" href="home">Inicio</a>
              </li>
              <!-- <li id="menu-item-167418" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-167418">
                <a target="_blank" rel="noopener noreferrer" href="about">Nosotros</a>
              </li> -->
              <li id="menu-item-167954" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-167954">
                <a href="services">Servicios</a>
              </li>
              <li id="menu-item-167423" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-167423">
                <a href="contact">Contacto</a>
              </li>

              <li id="menu-item-167423" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-167423">
                <a href="faqs">Preguntas frecuentes</a>
              </li>
              <!-- <li id="menu-item-167955" class="menu-item menu-item-type-post_type_archive menu-item-object-customer menu-item-167955">
                <a href="#">Customers</a>
              </li>
              <li id="menu-item-170700" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-170700">
                <a href="#">Testimonios</a>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer-content-column">
          <div class="footer-call-to-action">
            <h2 class="footer-call-to-action-title">Reserva ahora una sesión de videollamada</h2>
            <p class="footer-call-to-action-description"> No te quedes con dudas, reserva ahora tu videollamada para obtener la información que necesitas. Te esperamos! </p>
            <a class="footer-call-to-action-button button" (click)="goToContactPage()">Contactar ahora</a>
          </div>
          <!-- <div class="footer-call-to-action">
            <h2 class="footer-call-to-action-title">Nos adaptamos a tu dispositivo</h2>
            <app-responsive-animation></app-responsive-animation>
            <p class="footer-call-to-action-link-wrapper"> <a class="footer-call-to-action-link" href="tel:0124-64XXXX" target="_self"></a></p>
          </div> -->
        </div>
        <div class="footer-social-links"> <svg class="footer-social-amoeba-svg" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 236 54">
            <path class="footer-social-amoeba-path" d="M223.06,43.32c-.77-7.2,1.87-28.47-20-32.53C187.78,8,180.41,18,178.32,20.7s-5.63,10.1-4.07,16.7-.13,15.23-4.06,15.91-8.75-2.9-6.89-7S167.41,36,167.15,33a18.93,18.93,0,0,0-2.64-8.53c-3.44-5.5-8-11.19-19.12-11.19a21.64,21.64,0,0,0-18.31,9.18c-2.08,2.7-5.66,9.6-4.07,16.69s.64,14.32-6.11,13.9S108.35,46.5,112,36.54s-1.89-21.24-4-23.94S96.34,0,85.23,0,57.46,8.84,56.49,24.56s6.92,20.79,7,24.59c.07,2.75-6.43,4.16-12.92,2.38s-4-10.75-3.46-12.38c1.85-6.6-2-14-4.08-16.69a21.62,21.62,0,0,0-18.3-9.18C13.62,13.28,9.06,19,5.62,24.47A18.81,18.81,0,0,0,3,33a21.85,21.85,0,0,0,1.58,9.08,16.58,16.58,0,0,1,1.06,5A6.75,6.75,0,0,1,0,54H236C235.47,54,223.83,50.52,223.06,43.32Z"></path>
          </svg>
          <!-- <a class="footer-social-link linkedin" href="#" target="_blank">
            <span class="hidden-link-text">Linkedin</span>
            <svg class="footer-social-icon-svg" xmlns="https://www.w3.org/2000/svg"
              viewBox="0 0 30 30">
              <path class="footer-social-icon-path" d="M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065 c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z"></path>
            </svg>
          </a> -->
          <a class="footer-social-link instagram" href="https://www.instagram.com/voyjaleas/" target="_blank">
            <span class="hidden-link-text">Instagram</span>
            <i class="fab fa-instagram"></i>
          </a>
          <a class="footer-social-link youtube" href="https://www.youtube.com/channel/UCit3Q1coPtnglHq8T-85bdA" target="_blank">
            <span class="hidden-link-text">Youtube</span>
            <svg class="footer-social-icon-svg" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 30 30">
              <path class="footer-social-icon-path" d="M 15 4 C 10.814 4 5.3808594 5.0488281 5.3808594 5.0488281 L 5.3671875 5.0644531 C 3.4606632 5.3693645 2 7.0076245 2 9 L 2 15 L 2 15.001953 L 2 21 L 2 21.001953 A 4 4 0 0 0 5.3769531 24.945312 L 5.3808594 24.951172 C 5.3808594 24.951172 10.814 26.001953 15 26.001953 C 19.186 26.001953 24.619141 24.951172 24.619141 24.951172 L 24.621094 24.949219 A 4 4 0 0 0 28 21.001953 L 28 21 L 28 15.001953 L 28 15 L 28 9 A 4 4 0 0 0 24.623047 5.0546875 L 24.619141 5.0488281 C 24.619141 5.0488281 19.186 4 15 4 z M 12 10.398438 L 20 15 L 12 19.601562 L 12 10.398438 z"></path>
            </svg>
          </a>
          <a class="footer-social-link facebook" href="https://www.facebook.com/voyjaleas" target="_blank">
            <i class="fab fa-facebook-f" href="https://www.facebook.com/voyjaleas"></i>
          </a>
        </div>
      </div>
      <div class="footer-copyright">
        <div class="footer-copyright-wrapper">
          <p class="footer-copyright-text">
            <a class="footer-copyright-link" target="_self"> ©{{currentYear}} | {{companyName}} | All rights reserved. </a>
          </p>
        </div>
      </div>
    </footer>
  </div>
  